import { render, staticRenderFns } from "./NotificationsContainer.vue?vue&type=template&id=0c4c1eb3&scoped=true&"
import script from "./NotificationsContainer.vue?vue&type=script&lang=js&"
export * from "./NotificationsContainer.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsContainer.vue?vue&type=style&index=0&id=0c4c1eb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c1eb3",
  null
  
)

export default component.exports